import axios from 'axios';
import PropTypes from 'prop-types';
import React from 'react';
import { truncateWithEllipsis } from '../../../../../utilities/ui_utilities';
import ButtonWithChildren from '../../../../Input/ButtonWithChildren/ButtonWithChildren';
import { buildImagePath } from '../../../../JobComponents/Company/Image/logo';
import { CREATE_LAYOUT } from '../../LoginLayoutComponent';
import FacebookButton from '../../SocialMediaButtons/FacebookButton/FacebookButton';
import GoogleButton from '../../SocialMediaButtons/GoogleButton/GoogleButton';
import EmailLoginForm from '../EmailLoginForm/EmailLoginForm';
import { PageContext } from '../../../../../contexts/ContextCreator';
import './CreateAccountLayout.scss';

const LOGIN_TRIGGER_COOKIE = 'LOGIN-TRIGGER';

export default class CreateAccountLayout extends React.PureComponent {
    constructor(props) {
        super();
        this.state = {
            showEmailForm: false,
            signUpRedirectPath: props.signupRedirectPath,
        };
    }

    static propTypes = {
        /**
         * redirect path after signup
         */
        signupRedirectPath: PropTypes.string.isRequired,
        /**
         * auth0 config
         */
        auth0: PropTypes.shape({
            domain: PropTypes.string,
            clientId: PropTypes.string,
            db: PropTypes.string,
        }).isRequired,
        /**
         * login function to call after success for sign up
         */
        onLogin: PropTypes.func.isRequired,
        /**
         * callback function to handle auth0 errors
         */
        handleAuth0Error: PropTypes.func.isRequired,
        /**
         * resetsAuth0 errors function
         */
        setAuth0ErrorMsg: PropTypes.func,
        /**
         * function to handle email input
         */
        handleEmailInput: PropTypes.func.isRequired,
        /**
         * function to handle password input
         */
        handlePasswordInput: PropTypes.func.isRequired,
        /**
         * function to handle usernameInput
         */
        handleUsernameInput: PropTypes.func,
        /**
         * function to handle name input
         */
        handleNameInput: PropTypes.func,
        /**
         * email value
         */
        email: PropTypes.string,
        /**
         * password value
         */
        password: PropTypes.string,
        /**
         * username value
         */
        username: PropTypes.string,
        /**
         * email error
         */
        emailError: PropTypes.string,
        /**
         * password error
         */
        passwordError: PropTypes.string,
        /**
         * general Error
         */
        generalError: PropTypes.string,
        /**
         * username error
         */
        usernameError: PropTypes.string,
        /**
         * name error
         */
        name: PropTypes.string,
        /**
         * function to set loaded state for loader component
         */
        setLoadedStateForLoaderComponent: PropTypes.func.isRequired,
        /**
         * The secondary subtitle text
         */
        callToActionSubTitle: PropTypes.string,
        /**
         * state passed down on whether the call has finished processing
         */
        loaded: PropTypes.bool,
        showUsernameField: PropTypes.bool,
    };

    static defaultProps = {
        callToActionSubTitle:
            'Join millions of women sharing advice, finding jobs and making connections.',
        showUsernameField: true,
    };

    static contextType = PageContext;

    openEmailForm = () => {
        this.setState({
            showEmailForm: true,
        });
    };
    onSignUpInternal = async () => {
        this.props.setLoadedStateForLoaderComponent(false);
        const redirectPath = this.props.signupRedirectPath;

        let metaData = {
            inviteHash: this.props.inviteHash,
            groupInviteHash: this.props.groupInviteHash,
            connectionInviteHash: this.props.connectionInviteHash,
            employerInviteHash: this.props.employerInviteHash,
            redirectPath,
        };

        try {
            const payload = {
                email: this.props.email,
                password: this.props.password,
                name: this.props.name,
                metaData,
            };

            const result = await axios.post(
                `/auth-v2/user-pass/register`,
                payload
            );

            let data = result.data;
            if (data.success === true) {
                const loginRedirect = this.props.signupRedirectPath
                    ? this.props.signupRedirectPath
                    : '/';
                this.setState({
                    signUpRedirectPath: this.props.signupRedirectPath,
                });
                this.onSignUpSuccess(loginRedirect);
            } else {
                this.props.setLoadedStateForLoaderComponent(true);
                this.props.handleAuth0Error({ code: data.err }, 'Sign Up');
            }
        } catch (err) {
            console.error(err);
            this.props.setLoadedStateForLoaderComponent(true);
        }
    };

    onSignUpSuccess = (loginRedirect) => {
        setTimeout(() => this.props.onLogin('local', loginRedirect), 1000);
    };

    renderEmailButton = () => {
        const iconSrc = buildImagePath('/v1541017253/Login/Mail.png', 'button');
        return !this.state.showEmailForm ? (
            <ButtonWithChildren
                className={`email-button`}
                onClick={this.openEmailForm}
            >
                <div className="button-content-container">
                    <img src={iconSrc} />
                    <div
                        className="call-to-action-button-text"
                        data-qa="continue"
                    >
                        Continue with email
                    </div>
                </div>
            </ButtonWithChildren>
        ) : null;
    };

    render() {
        return (
            <div className="component-Login-LoginLayoutComponent-Layouts-CreateAccountLayout">
                {!this.state.showEmailForm ? (
                    <div className="login-subText-call-to-action-component">
                        {truncateWithEllipsis(
                            this.props.callToActionSubTitle,
                            80
                        )}
                    </div>
                ) : null}
                <FacebookButton onClick={this.props.onLogin} />
                <GoogleButton onClick={this.props.onLogin} />
                {this.renderEmailButton()}
                {!this.state.showEmailForm ? null : (
                    <EmailLoginForm
                        location={CREATE_LAYOUT}
                        featureFlags={
                            this.context &&
                            this.context.pageProps &&
                            this.context.pageProps.featureFlags
                        }
                        showUsernameField={this.props.showUsernameField}
                        onClick={this.onSignUpInternal}
                        handleEmailInput={this.props.handleEmailInput}
                        handlePasswordInput={this.props.handlePasswordInput}
                        handleUsernameInput={this.props.handleUsernameInput}
                        handleNameInput={this.props.handleNameInput}
                        email={this.props.email}
                        username={this.props.username}
                        name={this.props.name}
                        password={this.props.password}
                        nameError={this.props.nameError}
                        emailError={this.props.emailError}
                        passwordError={this.props.passwordError}
                        usernameError={this.props.usernameError}
                        generalError={this.props.generalError}
                        loaded={this.props.loaded}
                    />
                )}
            </div>
        );
    }
}
